import React from 'react';
import { Container, Col, Row } from '../../components/grid';
import {
  Heading1,
  Heading2,
  Paragraph,
  List,
  LinkStyled,
} from '../../components/typography';
import { ItemTraverser } from '../../containers/commerce';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import ProductView1 from '../../components/commerce/ProductViews/ProductView1';
import RowProductView from '../../components/grid/RowProductView';

export default () => (
  <SidemenuLayout menuPicker="Fadoel" activeSidemenu="Hvede">
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0px">
          <Heading1>Hvedeøl</Heading1>
        </Col>
        <Col xs={12} paddingTop="0px">
          <Paragraph>
            Hvedeøl på fad er en skøn tørstslukker til både fester og arrangementer, og øllen kan ofte kendes på dens meget fyldige smag og lidt uklare farve. Hos Skafte finder du et stort udvalg af hvedeøl, herunder de velkendte varianter af tysk hvedeøl, men også dansk og belgisk hvedeøl. Prøv fx en skøn hvedeøl fra Herslev, Hoegaarden, Kronenbourg, Erdinger, Grimbergen, Franziskaner og Paulaner. Husk også at leje et <LinkStyled to="/fadoelsanlaeg">fadølsanlæg</LinkStyled> til fustager.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="fadoelHvedeoel" filterFadkobling filterLiterSize filterLiterPrice display={ProductView1} />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col md={12}>
          <Heading2>Skøn hvedeøl på fad</Heading2>
          <Paragraph>
            Hos Skafte finder du et stort udvalg af dejlige hvedeøl på fad - perfekt til din næste fest eller arrangement. Husk, at du hos Skafte også kan leje både fadølsanlæg og udstyr, så du kan skænke en iskold og frisk hvedeøl.
          </Paragraph>
          <Paragraph>
            Her på siden finder du et bredt sortiment af hvedeøl på fad og du kan bl.a. gå på spændende opdagelse i:
          </Paragraph>
          <List>
            <li>Dansk hvedeøl</li>
            <li>Tysk hvedeøl</li>
            <li>Belgisk hvedeøl</li>
            <li>Fransk hvedeøl</li>
          </List>
          <Paragraph>
            Hvedeøl på fad er en sublim tilføjelse til både festen eller arrangementet, uanset om det er til privat eller erhverv. En frisk skænket fadøl er bare endnu mere lækker end en flaske eller dåse og du får den fulde øl-oplevelse, når øllen skænkes i glasset. Desuden er øllen altid frisk og du slipper for at skulle fylde et helt køleskab, for at kunne nyde en dejlig kold øl.
          </Paragraph>
          <Paragraph>
            Langt de fleste hvedeøl i vores sortiment leveres i en fustage med enten A- eller S-tilkobling til et fadølsanlæg. Hvis du vælger at bestille en eller flere fustager med hvedeøl (eller anden øl) og i samme moment lejer et fadølsanlæg, sørger vi naturligvis for at tilkoblingen til fustagerne passer sammen.
          </Paragraph>
          <Paragraph>
            Gå på opdagelse i en verden af hvedeøl og sluk tørsten i den gyldne væske.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col md={12}>
          <Heading2>Hvedeøl og dens karakteristika</Heading2>
          <Paragraph>
            Kær hvedeøl har mange navne. Den skønne øl brygget på hvede er nemlig også kendt under navne som weissbier/weißbier, hefeweizen og weizenbier på tysk, samt witbier i Belgien. Trods de mange navne, så refererer de alle tilbage til én og samme øl; nemlig hvedeøllen.
          </Paragraph>
          <Paragraph>
            Ligesom navnet hentyder, så er en hvedeøl brygget på hvede. De fleste øl brygges på bygmalt og denne danner basen for selve øllen. En hvedeøl er også brygget på bygmalt, men omkring halvdelen er skiftet ud med hvedemalt i stedet.
          </Paragraph>
          <Paragraph>
            Hvedemalten er også med til at give øllen det karakteristiske uklare skær. Hvede har nemlig et højere proteinindhold end byg, der er næsten helt proteinfrit, hvilket giver en lidt uklar væske, medmindre at øllen bliver filtreret.
          </Paragraph>
          <Paragraph>
            Hvedeøl er den overordnede fortegnelse for de mange underkategorier der findes af øllen. Den har en oprindelse fra både Tyskland og Belgien og er en mangeårig tradition, der stadig er utroligt populær den dag i dag. De tyske varianter sælges ofte som værende weissbier eller hefeweizen, men der findes eksempelvis en videreudvikling kaldet weissbier dunkel, hvilket har en mørkere farve og dybere smag.
          </Paragraph>
          <Paragraph>
            Hvedeøl er en traditionelt overgæret øl og den byder oftest på en alkoholprocent mellem 4,6% - 5,8%, men dette afhænger naturligvis af typen. De fleste hvedeøl eller weissbier er uklare i glasset, hvilket er en del af oplevelsen. Det er gærrester og proteinet fra hvedemalten, der giver det uklare look.
            Når du drikker en lækker weißbier kan du forvente en sødlig og frugtig smag, men som samtidig har tendenser til en krydret oplevelse, og i nogle særlige tilfælde en let syrlig smag. Farven på hvedeøllen varierer primært fra værende hvid-gul til en gylden farve, mens skummet er enten hvidt eller cremefarvet. Nogle enkelte versioner, fx weissbier dunkel, vil opleves næsten mørk brun.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col md={12}>
          <Heading2>Dansk, belgisk og tysk hvedeøl</Heading2>
          <Paragraph>
            Hos Skafte har vi et stort udvalg af dejlig weizenbier fra flere lande. Du kan bl.a. smage dig gennem:
          </Paragraph>
          <List>
            <li>Herslev Bryghus Øko Hvede</li>
            <li>Hoegaarden</li>
            <li>Kronenbourg 1664 Blanc</li>
            <li>Nørrebro Bryghus Øko Stuykman Hvede</li>
            <li>Franziskaner Hefe</li>
            <li>Weihenstephaner Hefe-Weissbier Dunkel</li>
            <li>Paulaner Hefe-Weissbier Naturtrüb</li>
            <li>Erdinger Hefe Weissbier</li>
            <li>Grimbergen Blanche</li>
          </List>
          <Paragraph>
            Uanset om du og dine gæster er mest til en klassisk og traditionel belgisk hvedeøl eller en tysk hvedeøl, eller om I er mere til en fransk eller dansk version, så finder du den bedste hvedeøl på fad her på siden.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col md={12}>
          <Heading2>Hvad nydes hvedeøl bedst til?</Heading2>
          <Paragraph>
            En hvedeøl er skøn i sig selv og kan helt uden problemer nydes alene og som den er. Men har du planer om at servere mad til arrangementet, så læs med her - den lækre weissbier egner sig nemlig formidabelt til nogle retter, hvor den virkelig formår at trække maden og smagsoplevelsen op på et helt nyt niveau.
          </Paragraph>
          <Paragraph>
            Som tidligere nævnt, så har hvedeøl typisk en sødlig smag, der byder på frugtige noter, hvilket egner sig særligt godt til lette retter. Særligt de tyske hvedeøl egner sig godt til en fyldig salat eller retter med skinke og ost.
            Nogle typer af hvedeøl, heriblandt de belgiske hvedeøl, kan dog godt have en lidt mere syrlig smag, hvor du med fordel kan servere disse til dampet fisk og skaldyr. Prøv også at dampe blåmuslinger i witbier frem for hvidvin.
          </Paragraph>
          <Paragraph>
            Langt størstedelen af hvedeøl passer desuden rigtig godt til asiatiske retter.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col md={12}>
          <Heading2>Lej et fadølsanlæg samt udstyr og skænk en iskold hvedeøl</Heading2>
          <Paragraph>
            Hvad enten om du bestiller til en privatfest eller om det er til erhverv, så kan du både købe weissbier på fustage samt leje et fadølsanlæg hos os.
            Det er altid skønt at kunne tilbyde dine gæster eller kunder en frisk og kold fadøl, mens du samtidig slipper for de mange tomme flasker og dåser.
          </Paragraph>
          <Paragraph>
            Et fadølsanlæg giver festen et ekstra løft og forstærker hvedeøllets smag. Når du tapper fra hane, bliver skummet nemlig tættere og den karakteristiske smag fremhæves.
          </Paragraph>
          <Paragraph>
            Uanset om du bestiller til privat eller erhverv, så kan du returnere de uåbnede fustager, så du ikke brænder inde med den ellers lækre hvedeøl.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
